import React, { useState, useEffect } from 'react';
import data from './HelpData.json';
import GradeOutlinedIcon from '@material-ui/icons/GradeOutlined';
import ThumbUpOutlinedIcon from '@material-ui/icons/ThumbUpOutlined';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tile from './components/Tile';
import Instruction from './components/Instruction';
import Faq from './components/Faq';
import Form from './components/Form';
import animate from 'utilities/animate';
import './Help.css';

const Help = () => {
    const [formType, set_formType] = useState('contact');
    const [contactColor, set_contactColor] = useState('');
    const [feedbackColor, set_feedbackColor] = useState('');

    const scrollTo = (section, formType) => {
        const element = document.getElementById(section);
        element.scrollIntoView({ behavior: 'smooth' });

        if (formType) set_formType(formType);
    };

    useEffect(() => {
        const color_active = { red: 49, green: 144, blue: 217 };
        const color_inactive = { red: 255, green: 255, blue: 255 };
        const animation_time = 250;

        const changeColor = (fraction, setFunc, forwards = true, left = true) => {
            let fraction_adj;
            if (fraction < 0.5) fraction_adj = forwards ? 1 - fraction * 2 : fraction * 2;
            else fraction_adj = forwards ? 1 - (fraction - 0.5) * 2 : (fraction - 0.5) * 2;

            const newRed = color_active.red * (1 - fraction_adj) + color_inactive.red * fraction_adj;
            const newGreen = color_active.green * (1 - fraction_adj) + color_inactive.green * fraction_adj;
            const newBlue = color_active.blue * (1 - fraction_adj) + color_inactive.blue * fraction_adj;

            const finalColor = forwards ^ (fraction < 0.5) ? color_active : color_inactive;
            const finalColor_str = `rgb(${finalColor.red},${finalColor.green},${finalColor.blue})`;

            const newColor_str = `rgb(${newRed},${newGreen},${newBlue})`;

            if (forwards ^ (fraction < 0.5) ^ left) setFunc(`linear-gradient(90deg, ${finalColor_str}, ${newColor_str})`);
            else setFunc(`linear-gradient(90deg, ${newColor_str}, ${finalColor_str})`);
        };

        animate({
            timing: (t) => t,
            draw: (fraction) => {
                const isContact = formType === 'contact';
                changeColor(fraction, set_contactColor, isContact, true);
                changeColor(fraction, set_feedbackColor, !isContact, false);
            },
            duration: animation_time,
        });
    }, [formType]);

    return (
        <div className='page-container'>
            {/* HEADER */}
            <div style={styles.header} id='header'>
                <h1>Qdash Help!</h1>
                <p>Qdash is primarily supported by the individual sites. Depending on your issue you may need to contact different support teams.</p>
                <div className='tile-container'>
                    <div className='tile-column'>
                        <Tile
                            title='Getting Started'
                            subtitle='Learn how to use Qdash'
                            icon={<GradeOutlinedIcon fontSize='large' style={styles.tileIcon} />}
                            section='gettingStarted'
                            scrollTo={scrollTo}
                        />
                        <Tile
                            title="FAQ's"
                            subtitle='Take a look at the frequently asked questions'
                            icon={<ChatBubbleOutlineIcon size='large' style={styles.tileIcon} />}
                            section='faqs'
                            scrollTo={scrollTo}
                        />
                    </div>
                    <div className='tile-column'>
                        <Tile
                            title='Contact Us'
                            subtitle='Any questions about Qdash? We’d love to hear from you'
                            icon={<HelpOutlineIcon fontSize='large' style={styles.tileIcon} />}
                            section='contactForm'
                            formType='contact'
                            scrollTo={scrollTo}
                        />
                        <Tile
                            title='Feedback'
                            subtitle='Leave feedback on the application. New Ideas, features, or problems'
                            icon={<ThumbUpOutlinedIcon fontSize='large' style={styles.tileIcon} />}
                            section='contactForm'
                            formType='feedback'
                            scrollTo={scrollTo}
                        />
                    </div>
                </div>
            </div>

            {/* GETTING STARTED */}
            <div style={styles.section} id='gettingStarted'>
                <h1>Getting Started</h1>
                {data.instructions.map((item, key) => {
                    return <Instruction key={key} title={item.title} steps={item.steps} />;
                })}
                <p onClick={() => scrollTo('header')} className='back-to-top'>
                    Back to top
                </p>
            </div>

            {/* FAQS */}
            <div style={styles.section} id='faqs'>
                <h1>FAQ's</h1>
                {data.faqs.map((item, key) => {
                    return <Faq key={key} question={item.question} answer={item.answer} />;
                })}
                <p onClick={() => scrollTo('header')} className='back-to-top'>
                    Back to top
                </p>
            </div>

            {/* FEEDBACK/CONTACT US */}
            <div id='contactForm' style={styles.section}>
                <div className='toggle'>
                    <div
                        className={formType === 'contact' ? 'toggle-section toggle-active' : 'toggle-section'}
                        onClick={() => set_formType('contact')}
                        style={{ background: contactColor }}
                    >
                        Contact
                    </div>
                    <div
                        className={formType === 'feedback' ? 'toggle-section toggle-active' : 'toggle-section'}
                        onClick={() => set_formType('feedback')}
                        style={{ background: feedbackColor }}
                    >
                        Feedback
                    </div>
                </div>

                <Form type={formType} />
                <p onClick={() => scrollTo('header')} className='back-to-top'>
                    Back to top
                </p>
            </div>
        </div>
    );
};

export default Help;

const styles = {
    header: {
        textAlign: 'center',
        padding: '25px 0 50px 0',
    },
    section: {
        padding: '50px 0 0 0',
        borderTop: '1px solid #D4D4D4',
    },
    tileIcon: {
        color: '#3190d9',
        fontSize: '3rem',
    },
};
